// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/supply_bilateral_trade_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { BilateralTradeProductType } from "../../bfftypes/v1/bilateral_trade_product_type_pb";
import { file_bfftypes_v1_bilateral_trade_product_type } from "../../bfftypes/v1/bilateral_trade_product_type_pb";
import type { DeliveryCalendarKey } from "../../bfftypes/v1/delivery_calendar_key_pb";
import { file_bfftypes_v1_delivery_calendar_key } from "../../bfftypes/v1/delivery_calendar_key_pb";
import type { DeliveryDayBandState } from "../../bfftypes/v1/delivery_day_band_state_pb";
import { file_bfftypes_v1_delivery_day_band_state } from "../../bfftypes/v1/delivery_day_band_state_pb";
import type { LeadDayCountMethod } from "../../bfftypes/v1/lead_day_count_method_pb";
import { file_bfftypes_v1_lead_day_count_method } from "../../bfftypes/v1/lead_day_count_method_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { TradingContractStatus } from "../../bfftypes/v1/trading_contract_status_pb";
import { file_bfftypes_v1_trading_contract_status } from "../../bfftypes/v1/trading_contract_status_pb";
import type { TradingCustomDayCategory } from "../../bfftypes/v1/trading_custom_day_category_pb";
import { file_bfftypes_v1_trading_custom_day_category } from "../../bfftypes/v1/trading_custom_day_category_pb";
import type { TradingDeliveryType } from "../../bfftypes/v1/trading_delivery_type_pb";
import { file_bfftypes_v1_trading_delivery_type } from "../../bfftypes/v1/trading_delivery_type_pb";
import type { TradingExecutionRoute } from "../../bfftypes/v1/trading_execution_route_pb";
import { file_bfftypes_v1_trading_execution_route } from "../../bfftypes/v1/trading_execution_route_pb";
import type { TradingSpreadKind } from "../../bfftypes/v1/trading_spread_kind_pb";
import { file_bfftypes_v1_trading_spread_kind } from "../../bfftypes/v1/trading_spread_kind_pb";
import type { TradingTimeZoneType } from "../../bfftypes/v1/trading_time_zone_type_pb";
import { file_bfftypes_v1_trading_time_zone_type } from "../../bfftypes/v1/trading_time_zone_type_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { TimeOfDay } from "../../google/type/timeofday_pb";
import { file_google_type_timeofday } from "../../google/type/timeofday_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/supply_bilateral_trade_model.proto.
 */
export const file_bffuser_v1_supply_bilateral_trade_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_bilateral_trade_product_type, file_bfftypes_v1_delivery_calendar_key, file_bfftypes_v1_delivery_day_band_state, file_bfftypes_v1_lead_day_count_method, file_bfftypes_v1_side, file_bfftypes_v1_trading_contract_status, file_bfftypes_v1_trading_custom_day_category, file_bfftypes_v1_trading_delivery_type, file_bfftypes_v1_trading_execution_route, file_bfftypes_v1_trading_spread_kind, file_bfftypes_v1_trading_time_zone_type, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal, file_google_type_timeofday]);

/**
 * BilateralTradeImportStaleness is the AC-SBL-016 banner state of the 取り込み
 * (外部連携) 途絶. 連携元名 (eSL / eNgine) は含めない。
 * Mirrors internalapi.v1.BilateralTradeImportStaleness.
 *
 * @generated from message bffuser.v1.BilateralTradeImportStaleness
 */
export type BilateralTradeImportStaleness = Message<"bffuser.v1.BilateralTradeImportStaleness"> & {
  /**
   * 稼働中の連携元のいずれかの取り込みが途絶えている時 true。
   *
   * @generated from field: bool stale = 1;
   */
  stale: boolean;

  /**
   * stale=true の時、途絶えている連携元の最後に取り込みに成功した日時の最小値。
   * 途絶えている連携元に一度も成功していないものが含まれる時は未設定 (画面は「—」)。
   *
   * @generated from field: optional google.protobuf.Timestamp last_imported_at = 2;
   */
  lastImportedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.BilateralTradeImportStaleness.
 * Use `create(BilateralTradeImportStalenessSchema)` to create a new message.
 */
export const BilateralTradeImportStalenessSchema: GenMessage<BilateralTradeImportStaleness> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 0);

/**
 * BilateralTradeListItem is one row in the bilateral-trade list view.
 *
 * @generated from message bffuser.v1.BilateralTradeListItem
 */
export type BilateralTradeListItem = Message<"bffuser.v1.BilateralTradeListItem"> & {
  /**
   * 取引 UUID。削除 RPC に渡す識別子。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 約定日。
   *
   * @generated from field: google.type.Date execution_date = 2;
   */
  executionDate?: Date;

  /**
   * 取引経路 (enechain / eSquare Live / 手入力)。
   *
   * @generated from field: bfftypes.v1.TradingExecutionRoute execution_route = 3;
   */
  executionRoute: TradingExecutionRoute;

  /**
   * 成約 ID (取引プラットフォームが採番した公開 ID)。
   *
   * @generated from field: string public_trade_id = 4;
   */
  publicTradeId: string;

  /**
   * 相対先の名称。
   *
   * @generated from field: string partner_name = 5;
   */
  partnerName: string;

  /**
   * 売買区分。
   *
   * @generated from field: bfftypes.v1.Side buy_sell = 6;
   */
  buySell: Side;

  /**
   * エリアコード。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 7;
   */
  areaCode: AreaCode;

  /**
   * 受渡期間 (開始日)。
   *
   * @generated from field: google.type.Date delivery_period_from = 8;
   */
  deliveryPeriodFrom?: Date;

  /**
   * 受渡期間 (終了日)。
   *
   * @generated from field: google.type.Date delivery_period_to = 9;
   */
  deliveryPeriodTo?: Date;

  /**
   * 受渡区分 (enum 固定値)。 旧 master 化 (delivery_type_id UUID) を廃止し enum に変更。
   * frontend は enum 値から表示名 / 派生属性をマッピング関数で解決する (マスタ行 fetch 不要)。
   *
   * @generated from field: bfftypes.v1.TradingDeliveryType delivery_type = 10;
   */
  deliveryType: TradingDeliveryType;

  /**
   * タイムゾーン区分 (BASE / PEAK / OFF_PEAK)。契約に永続化された
   * 値をそのまま返す (分類・正規化しない — issues #7762 / #7780 / #7782、
   * 2026-09-14 PdM 判断)。**UNSPECIFIED = 時間帯 enum を持たない契約**
   * (単票 BilateralTrade.time_zone_type と同じ意味) で、カスタム時間帯なら
   * custom_bands に時刻レンジが載り、商品形態=非定型なら custom_bands も空。
   * 時間帯フィルタ (AC-SBL-047) の分類は本フィールドとは独立に評価する。
   *
   * @generated from field: bfftypes.v1.TradingTimeZoneType time_zone_type = 11;
   */
  timeZoneType: TradingTimeZoneType;

  /**
   * オプション条項あり/なし。
   *
   * @generated from field: bool has_option = 12;
   */
  hasOption: boolean;

  /**
   * 実績利用率 (0-1 スケール、 例: 0.7 は 70%)。has_option=false の場合は unset。
   *
   * @generated from field: google.type.Decimal actual_utilization_rate = 13;
   */
  actualUtilizationRate?: Decimal;

  /**
   * 利用率下限 (0-1 スケール、 例: 0.7 は 70%)。has_option=false の場合は unset。
   *
   * @generated from field: google.type.Decimal utilization_rate_min = 14;
   */
  utilizationRateMin?: Decimal;

  /**
   * 利用率上限 (0-1 スケール、 例: 0.7 は 70%)。has_option=false の場合は unset。
   *
   * @generated from field: google.type.Decimal utilization_rate_max = 15;
   */
  utilizationRateMax?: Decimal;

  /**
   * 契約電力量 (MW)。
   *
   * @generated from field: google.type.Decimal volume_mw = 16;
   */
  volumeMw?: Decimal;

  /**
   * 手入力行フラグ。true の場合のみ削除ボタンを表示する。
   *
   * @generated from field: bool is_manual = 17;
   */
  isManual: boolean;

  /**
   * 楽観的排他制御用のタイムスタンプ (µs 精度)。
   * DeleteBilateralTrade の expected_updated_at に round-trip する
   * (proto Timestamp のまま保持すること)。
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 18;
   */
  updatedAt?: Timestamp;

  /**
   * 最終更新者のユーザー識別子。
   *
   * @generated from field: string updated_by = 19;
   */
  updatedBy: string;

  /**
   * ライフサイクル状態。
   *
   * @generated from field: bfftypes.v1.TradingContractStatus status = 20;
   */
  status: TradingContractStatus;

  /**
   * 契約単価 (円/kWh)。精度敏感のため google.type.Decimal。unset 可。
   *
   * @generated from field: google.type.Decimal unit_price_yen_per_kwh = 21;
   */
  unitPriceYenPerKwh?: Decimal;

  /**
   * 商品形態 (標準 / スプレッド / 非定型)。永続化されない導出値で、一覧の
   * 商品形態バッジに使う (スプレッド = deal_id 共有の 2 行 /
   * 非定型 = 1 行。非定型は 1 取引 = 1 数量・単価単位)。
   *
   * @generated from field: bfftypes.v1.BilateralTradeProductType product_type = 22;
   */
  productType: BilateralTradeProductType;

  /**
   * 成約 ID (社内採番 SC-YYYYMMDD-NNN)。スプレッドの 2 行を画面上で束ねる
   * グルーピングキー (UK ではない)。
   *
   * @generated from field: string deal_id = 23;
   */
  dealId: string;

  /**
   * カスタム時間帯の 日区分 ↔ 時刻レンジ ペア列 (issue #6698)。契約に永続化
   * された ペア列 をそのまま載せる。time_zone_type と排他 (どちらか一方のみ
   * 非空。両方空 = 商品形態=非定型 で、画面は「—」を出す)。
   * BilateralTrade.custom_bands (単票 message) と同じ CustomBand 形状。
   *
   * @generated from field: repeated bffuser.v1.CustomBand custom_bands = 25;
   */
  customBands: CustomBand[];

  /**
   * 取引先コード (取引先 BG / 計画提出者コード 5 桁、契約時スナップショット)。
   * 一覧の「取引先」列で名称に括弧併記する (issue #7045)。未登録は空文字。
   * BilateralTrade.partner_submission_entity_code (単票 message) と同じ値。
   * Mirrors internalapi.v1.BilateralTradeListItem.partner_submission_entity_code.
   *
   * @generated from field: string partner_submission_entity_code = 26;
   */
  partnerSubmissionEntityCode: string;
};

/**
 * Describes the message bffuser.v1.BilateralTradeListItem.
 * Use `create(BilateralTradeListItemSchema)` to create a new message.
 */
export const BilateralTradeListItemSchema: GenMessage<BilateralTradeListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 1);

/**
 * BilateralTradeSummary aggregates key metrics across all trades that match
 * the current filter (before pagination).
 *
 * @generated from message bffuser.v1.BilateralTradeSummary
 */
export type BilateralTradeSummary = Message<"bffuser.v1.BilateralTradeSummary"> & {
  /**
   * 買い合計 (MW)。
   *
   * @generated from field: google.type.Decimal buy_total_mw = 1;
   */
  buyTotalMw?: Decimal;

  /**
   * 売り合計 (MW)。
   *
   * @generated from field: google.type.Decimal sell_total_mw = 2;
   */
  sellTotalMw?: Decimal;

  /**
   * ネットポジション = 買い - 売り (MW)。
   *
   * @generated from field: google.type.Decimal net_mw = 3;
   */
  netMw?: Decimal;

  /**
   * 買い合計 (kWh)。
   *
   * @generated from field: google.type.Decimal buy_total_kwh = 4;
   */
  buyTotalKwh?: Decimal;

  /**
   * 売り合計 (kWh)。
   *
   * @generated from field: google.type.Decimal sell_total_kwh = 5;
   */
  sellTotalKwh?: Decimal;

  /**
   * ネットポジション (kWh)。
   *
   * @generated from field: google.type.Decimal net_kwh = 6;
   */
  netKwh?: Decimal;

  /**
   * フィルタ一致件数合計。
   *
   * @generated from field: int32 trade_count = 7;
   */
  tradeCount: number;

  /**
   * 買い件数。
   *
   * @generated from field: int32 buy_count = 8;
   */
  buyCount: number;

  /**
   * 売り件数。
   *
   * @generated from field: int32 sell_count = 9;
   */
  sellCount: number;
};

/**
 * Describes the message bffuser.v1.BilateralTradeSummary.
 * Use `create(BilateralTradeSummarySchema)` to create a new message.
 */
export const BilateralTradeSummarySchema: GenMessage<BilateralTradeSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 2);

/**
 * BilateralTradeMonthlyGroup groups bilateral trade items by calendar month
 * for the monthly-grouping display mode.
 *
 * @generated from message bffuser.v1.BilateralTradeMonthlyGroup
 */
export type BilateralTradeMonthlyGroup = Message<"bffuser.v1.BilateralTradeMonthlyGroup"> & {
  /**
   * 年 (例: 2024)。
   *
   * @generated from field: int32 year = 1;
   */
  year: number;

  /**
   * 月 (1-12)。
   *
   * @generated from field: int32 month = 2;
   */
  month: number;

  /**
   * 当月内の取引件数。
   *
   * @generated from field: int32 count = 3;
   */
  count: number;

  /**
   * 当月内の契約電力量合計 (MW)。
   *
   * @generated from field: google.type.Decimal total_mw = 4;
   */
  totalMw?: Decimal;

  /**
   * 当月内の電力量合計 (kWh)。
   *
   * @generated from field: google.type.Decimal total_kwh = 5;
   */
  totalKwh?: Decimal;

  /**
   * 当月内の取引一覧。
   *
   * @generated from field: repeated bffuser.v1.BilateralTradeListItem items = 6;
   */
  items: BilateralTradeListItem[];
};

/**
 * Describes the message bffuser.v1.BilateralTradeMonthlyGroup.
 * Use `create(BilateralTradeMonthlyGroupSchema)` to create a new message.
 */
export const BilateralTradeMonthlyGroupSchema: GenMessage<BilateralTradeMonthlyGroup> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 3);

/**
 * BilateralTradeOptionInput は Create/Update 共通のオプション通告ルール入力。
 * is_option=true の場合のみ参照する。
 *
 * 週次通告 (has_weekly_notice=true) 時のみ使用するフィールド:
 *   weekly_start_day_of_week / weekly_span_days / weekly_notice_lead_days /
 *   weekly_notice_cutoff_time。
 *
 * Decimal フィールド (option_base_fee_per_mw) の値域は proto では presence のみ
 * 宣言し、値域検証は domain 側で担保する。
 *
 * 利用率下限 / 上限は本 message から BilateralTradeInput ヘッダーへ移設済み
 * (利用率をオプション設定から独立した契約属性へ。追跡 #4580)。
 * Mirrors internalapi.v1.BilateralTradeOptionInput.
 *
 * @generated from message bffuser.v1.BilateralTradeOptionInput
 */
export type BilateralTradeOptionInput = Message<"bffuser.v1.BilateralTradeOptionInput"> & {
  /**
   * 日次通告: 実需給の N 日前。0 以上。
   *
   * @generated from field: int32 daily_notice_lead_days = 1;
   */
  dailyNoticeLeadDays: number;

  /**
   * 日次通告の締切時刻 (JST HH:MM)。
   *
   * @generated from field: google.type.TimeOfDay daily_notice_cutoff_time = 2;
   */
  dailyNoticeCutoffTime?: TimeOfDay;

  /**
   * リードタイム日数の換算方式 (暦日 / 営業日)。
   *
   * @generated from field: bfftypes.v1.LeadDayCountMethod daily_lead_day_count_method = 3;
   */
  dailyLeadDayCountMethod: LeadDayCountMethod;

  /**
   * 週次通告有無。true の場合は weekly_* フィールドを使用する。
   *
   * @generated from field: bool has_weekly_notice = 4;
   */
  hasWeeklyNotice: boolean;

  /**
   * 週次通告の週起算曜日 (ISO 8601: 1=Mon..7=Sun)。
   * has_weekly_notice=true 時のみ参照する。値域は domain 層で担保 (1-7)。
   *
   * @generated from field: int32 weekly_start_day_of_week = 5;
   */
  weeklyStartDayOfWeek: number;

  /**
   * 週次通告の対象日数。has_weekly_notice=true 時のみ参照する。1-14 の範囲。
   *
   * @generated from field: int32 weekly_span_days = 6;
   */
  weeklySpanDays: number;

  /**
   * 週次通告: 実需給の N 日前。has_weekly_notice=true 時のみ参照する。0 以上。
   *
   * @generated from field: int32 weekly_notice_lead_days = 7;
   */
  weeklyNoticeLeadDays: number;

  /**
   * 週次通告の締切時刻 (JST HH:MM)。has_weekly_notice=true 時のみ参照する。
   *
   * @generated from field: google.type.TimeOfDay weekly_notice_cutoff_time = 8;
   */
  weeklyNoticeCutoffTime?: TimeOfDay;

  /**
   * オプション基本料金 (円/MW・月)。任意。
   *
   * @generated from field: optional google.type.Decimal option_base_fee_per_mw = 11;
   */
  optionBaseFeePerMw?: Decimal;

  /**
   * オプション備考 (任意)。オプション設定は CSV から撤去済み (#4577) のため
   * 個別入力画面 spec `docs/specs/supply/bilateral-trade-manual-detail.md` の項目。
   * spec に明示上限が無いため max_len 500 は
   * `docs/specs/guidelines/input-character-limits.md` の長文自由記述系推奨値を準用。
   *
   * @generated from field: optional string option_remarks = 12;
   */
  optionRemarks?: string;
};

/**
 * Describes the message bffuser.v1.BilateralTradeOptionInput.
 * Use `create(BilateralTradeOptionInputSchema)` to create a new message.
 */
export const BilateralTradeOptionInputSchema: GenMessage<BilateralTradeOptionInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 4);

/**
 * TimeSlot はカスタム時間帯 1 区間の "HH:MM" 時刻ペア (start 以上 end 未満)。
 * end には日終端を表す "24:00" を許す。30 分境界 / 重なり禁止 / コマ配列との
 * 可逆変換は domain 側で検証・変換する。
 * Mirrors internalapi.v1.TimeSlot.
 *
 * @generated from message bffuser.v1.TimeSlot
 */
export type TimeSlot = Message<"bffuser.v1.TimeSlot"> & {
  /**
   * 開始時刻 "HH:MM" (30 分境界)。
   *
   * @generated from field: string start = 1;
   */
  start: string;

  /**
   * 終了時刻 "HH:MM" (30 分境界、"24:00" = 日終端)。
   *
   * @generated from field: string end = 2;
   */
  end: string;
};

/**
 * Describes the message bffuser.v1.TimeSlot.
 * Use `create(TimeSlotSchema)` to create a new message.
 */
export const TimeSlotSchema: GenMessage<TimeSlot> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 5);

/**
 * CustomBand はカスタム時間帯の **日区分 ↔ 時刻レンジ 1 ペア**。
 *
 * CSV の 日区分 (列15) と 時間帯区分 (列16) はカンマ区切りの要素数を一致させ、
 * **同じ並び順で 1 対 1 のペア**として解釈する (直積ではない。spec
 * `docs/specs/admin/data/uploads/bilateral-trade.md` §2「日区分・時間帯区分の
 * ペア対応」、Discussion 決定 B 2026-08-25 / issue #5777)。
 *
 * 直積 (旧 custom_day_categories × custom_time_slots) では、日区分ごとに異なる
 * 時刻レンジを持つ非対称な契約 —— 旧オフピーク (平日 0:00-8:00 + 平日
 * 20:00-24:00 + 休日 終日) —— を 1 取引で表現できなかった。
 *
 * Mirrors internalapi.v1.CustomBand.
 *
 * @generated from message bffuser.v1.CustomBand
 */
export type CustomBand = Message<"bffuser.v1.CustomBand"> & {
  /**
   * ペアの日区分 (平日 / 休日 / 全日)。全日は別の値と併記できない (AC-DUB-037)。
   * 応答は集合を 3 値の単一値で返す (平日+休日 は 全日)。
   *
   * @generated from field: repeated bfftypes.v1.TradingCustomDayCategory day_categories = 1;
   */
  dayCategories: TradingCustomDayCategory[];

  /**
   * ペアの時刻区間。
   *
   * @generated from field: repeated bffuser.v1.TimeSlot time_slots = 2;
   */
  timeSlots: TimeSlot[];
};

/**
 * Describes the message bffuser.v1.CustomBand.
 * Use `create(CustomBandSchema)` to create a new message.
 */
export const CustomBandSchema: GenMessage<CustomBand> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 6);

/**
 * BilateralTradeCalendarException は契約単位・日単位の受渡カレンダー例外
 * (デリバリーカレンダー月グリッドのトグル 1 日ぶん)。
 * Mirrors internalapi.v1.BilateralTradeCalendarException.
 *
 * @generated from message bffuser.v1.BilateralTradeCalendarException
 */
export type BilateralTradeCalendarException = Message<"bffuser.v1.BilateralTradeCalendarException"> & {
  /**
   * 例外の対象日。
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * true = 対象外化 (当日の全コマを 0)、false = 対象化。
   *
   * @generated from field: bool is_excluded = 2;
   */
  isExcluded: boolean;
};

/**
 * Describes the message bffuser.v1.BilateralTradeCalendarException.
 * Use `create(BilateralTradeCalendarExceptionSchema)` to create a new message.
 */
export const BilateralTradeCalendarExceptionSchema: GenMessage<BilateralTradeCalendarException> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 7);

/**
 * DeliveryCalendarDay is one delivery date's resolved calendar-view state for
 * AC-SBM-007 (手入力取引閲覧モーダルの受渡期間カレンダービュー)。
 * GetBilateralTradeResponse でのみ populate される。
 * Mirrors internalapi.v1.DeliveryCalendarDay 1:1 (wire 値も同一)。backend が
 * 休日判定・時間帯区分の band 展開・受渡カレンダー例外の適用を計算済みで返す値
 * をそのまま運ぶだけで、BFF / frontend は再計算しない。
 *
 * @generated from message bffuser.v1.DeliveryCalendarDay
 */
export type DeliveryCalendarDay = Message<"bffuser.v1.DeliveryCalendarDay"> & {
  /**
   * 対象日 (受渡期間内)。
   *
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * 受渡カレンダー例外の適用後の、当該日の対象コマ規模区分。
   *
   * @generated from field: bfftypes.v1.DeliveryDayBandState band_state = 2;
   */
  bandState: DeliveryDayBandState;

  /**
   * 当該日に受渡カレンダー例外があるか。
   *
   * @generated from field: bool has_exception = 3;
   */
  hasException: boolean;

  /**
   * 例外の対象外化フラグ (has_exception=false のときは無視)。
   *
   * @generated from field: bool exception_is_excluded = 4;
   */
  exceptionIsExcluded: boolean;
};

/**
 * Describes the message bffuser.v1.DeliveryCalendarDay.
 * Use `create(DeliveryCalendarDaySchema)` to create a new message.
 */
export const DeliveryCalendarDaySchema: GenMessage<DeliveryCalendarDay> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 8);

/**
 * BilateralTradeInput は Create / Update / CSV 取込確定 共通の入力 message。
 *
 * #6236 (Design Decision 2) で旧 BilateralTradeLegInput (repeated legs) を
 * 撤去しフラット化した。1 取引 = 1 契約 = 1 数量・単価単位 (ADR
 * trading-contract-one-to-one) であり、スプレッドの対向脚は別取引として送る。
 * Mirrors internalapi.v1.BilateralTradeInput.
 *
 * @generated from message bffuser.v1.BilateralTradeInput
 */
export type BilateralTradeInput = Message<"bffuser.v1.BilateralTradeInput"> & {
  /**
   * 取引識別コード。**個別入力では空を許容** (空なら backend が採番する)。
   * CSV 経路ではチェック RPC が空欄行を行エラーにする。
   * max_len 20 は spec `docs/specs/admin/data/uploads/bilateral-trade.md` §2 列 3
   * 「社内一意、20 文字以内」(識別子系推奨値、
   * `guidelines/input-character-limits.md`) に準拠。CSV 経路の
   * `csvPublicTradeIDMaxLen` と同値。
   *
   * @generated from field: string public_trade_id = 13;
   */
  publicTradeId: string;

  /**
   * 約定日。
   *
   * @generated from field: google.type.Date execution_date = 14;
   */
  executionDate?: Date;

  /**
   * 約定経路 (7 値)。常時BU では 売買=買 / 受渡区分=BG でなければ backend が
   * InvalidArgument で拒否する。
   *
   * @generated from field: bfftypes.v1.TradingExecutionRoute execution_route = 15;
   */
  executionRoute: TradingExecutionRoute;

  /**
   * 商品形態 (標準 / スプレッド / 非定型)。永続化しない導出値。D3 以降
   * 標準/非定型は常に受理、スプレッドは Create/Update とも常に拒否
   * (既存スプレッド契約の訂正・削除は CSV 経路のみ)。
   *
   * @generated from field: bfftypes.v1.BilateralTradeProductType product_type = 16;
   */
  productType: BilateralTradeProductType;

  /**
   * 契約エリア (標準・非定型)。D3 以降スプレッドは Create/Update を受け付け
   * ない。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 17;
   */
  areaCode: AreaCode;

  /**
   * 取引先マスタ UUID。取引所取引では空を許容する。
   *
   * @generated from field: string trading_partner_id = 18;
   */
  tradingPartnerId: string;

  /**
   * 受渡区分。契約レベル単一入力。
   *
   * @generated from field: bfftypes.v1.TradingDeliveryType delivery_type = 19;
   */
  deliveryType: TradingDeliveryType;

  /**
   * スプレッド種別。D3 以降 product_type=SPREAD の Create/Update は常に拒否
   * されるため、この message 経由で非空になることは無い。
   *
   * @generated from field: repeated bfftypes.v1.TradingSpreadKind spread_kinds = 20;
   */
  spreadKinds: TradingSpreadKind[];

  /**
   * 利用率下限 (0-1 スケール)。契約レベル単一入力。
   *
   * @generated from field: google.type.Decimal utilization_rate_min = 21;
   */
  utilizationRateMin?: Decimal;

  /**
   * 利用率上限 (0-1 スケール)。契約レベル単一入力。
   *
   * @generated from field: google.type.Decimal utilization_rate_max = 22;
   */
  utilizationRateMax?: Decimal;

  /**
   * オプション有無。true の場合は option フィールドを参照する。
   *
   * @generated from field: bool is_option = 23;
   */
  isOption: boolean;

  /**
   * オプション通告ルール。is_option=true の場合のみ参照する。
   *
   * @generated from field: bffuser.v1.BilateralTradeOptionInput option = 24;
   */
  option?: BilateralTradeOptionInput;

  /**
   * 備考 (任意)。備考列は spec bilateral-trade.md §2 (L147) で CSV から撤去済みで
   * 個別入力画面のみの項目のため spec に明示上限が無く、max_len 500 は
   * `guidelines/input-character-limits.md` の長文自由記述系推奨値を準用する。
   *
   * @generated from field: optional string remarks = 25;
   */
  remarks?: string;

  /**
   * 売買区分。
   *
   * @generated from field: bfftypes.v1.Side buy_sell = 27;
   */
  buySell: Side;

  /**
   * 受渡開始日。
   *
   * @generated from field: google.type.Date delivery_period_from = 28;
   */
  deliveryPeriodFrom?: Date;

  /**
   * 受渡終了日。≥ delivery_period_from の検証は domain 側。
   *
   * @generated from field: google.type.Date delivery_period_to = 29;
   */
  deliveryPeriodTo?: Date;

  /**
   * 時間帯区分 (ベース / ピーク / オフピーク)。
   * **UNSPECIFIED = カスタム時間帯** を表す (= custom_bands を使う)。
   * CUSTOM enum 値は追加しない方針のため not_in: [0] を課さない。
   *
   * @generated from field: bfftypes.v1.TradingTimeZoneType time_zone_type = 30;
   */
  timeZoneType: TradingTimeZoneType;

  /**
   * カスタム時間帯の 日区分 ↔ 時刻レンジ ペア列。time_zone_type 未設定時のみ
   * 参照する。31 / 32 (custom_day_categories / custom_time_slots) の直積表現を
   * 置き換えたもの (#6691、spec §2「日区分・時間帯区分のペア対応」)。
   *
   * @generated from field: repeated bffuser.v1.CustomBand custom_bands = 40;
   */
  customBands: CustomBand[];

  /**
   * 契約電力量 (MW)。presence のみ; >0 と MW×500 整数は domain 側で担保。
   *
   * @generated from field: google.type.Decimal volume_mw = 33;
   */
  volumeMw?: Decimal;

  /**
   * 契約単価 (円/kWh)。任意。
   *
   * @generated from field: google.type.Decimal unit_price_yen_per_kwh = 34;
   */
  unitPriceYenPerKwh?: Decimal;

  /**
   * 自社 BG / 計画提出者コード (5 桁)。未指定時は自社設定から解決する。
   *
   * @generated from field: optional string own_submission_entity_code = 35;
   */
  ownSubmissionEntityCode?: string;

  /**
   * 取引先 BG / 計画提出者コード (5 桁)。未指定時は取引先マスタから解決する。
   *
   * @generated from field: optional string partner_submission_entity_code = 36;
   */
  partnerSubmissionEntityCode?: string;

  /**
   * 精算単価参照エリア。
   *
   * @generated from field: bfftypes.v1.AreaCode settlement_price_area_code = 37;
   */
  settlementPriceAreaCode: AreaCode;

  /**
   * 受給日カレンダー (14 値)。ベース時は未指定可。
   *
   * @generated from field: bfftypes.v1.DeliveryCalendarKey calendar_key = 38;
   */
  calendarKey: DeliveryCalendarKey;

  /**
   * 受渡カレンダー例外 (日単位)。個別入力のみ、CSV 経路では常に空。
   * 上限は受渡期間の日数を上回らない (= 期間内 / 日付重複禁止を entity が
   * 保証する) が、期間そのものが無制限なので多層で止める。
   *
   * @generated from field: repeated bffuser.v1.BilateralTradeCalendarException calendar_exceptions = 39;
   */
  calendarExceptions: BilateralTradeCalendarException[];
};

/**
 * Describes the message bffuser.v1.BilateralTradeInput.
 * Use `create(BilateralTradeInputSchema)` to create a new message.
 */
export const BilateralTradeInputSchema: GenMessage<BilateralTradeInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 9);

/**
 * BilateralTradeOption は BilateralTrade の full オプション情報 (response 用)。
 * 利用率下限 / 上限は BilateralTrade ヘッダーへ移設済み。
 * Mirrors internalapi.v1.BilateralTradeOption.
 *
 * @generated from message bffuser.v1.BilateralTradeOption
 */
export type BilateralTradeOption = Message<"bffuser.v1.BilateralTradeOption"> & {
  /**
   * 日次通告: 実需給の N 日前。
   *
   * @generated from field: int32 daily_notice_lead_days = 1;
   */
  dailyNoticeLeadDays: number;

  /**
   * 日次通告の締切時刻 (JST HH:MM)。
   *
   * @generated from field: google.type.TimeOfDay daily_notice_cutoff_time = 2;
   */
  dailyNoticeCutoffTime?: TimeOfDay;

  /**
   * リードタイム日数の換算方式。
   *
   * @generated from field: bfftypes.v1.LeadDayCountMethod daily_lead_day_count_method = 3;
   */
  dailyLeadDayCountMethod: LeadDayCountMethod;

  /**
   * 週次通告有無。
   *
   * @generated from field: bool has_weekly_notice = 4;
   */
  hasWeeklyNotice: boolean;

  /**
   * 週次通告の週起算曜日 (ISO 8601: 1=Mon..7=Sun)。
   * has_weekly_notice=false の場合は 0 (= proto3 default)。
   *
   * @generated from field: int32 weekly_start_day_of_week = 5;
   */
  weeklyStartDayOfWeek: number;

  /**
   * 週次通告の対象日数。has_weekly_notice=false の場合は 0。
   *
   * @generated from field: int32 weekly_span_days = 6;
   */
  weeklySpanDays: number;

  /**
   * 週次通告: 実需給の N 日前。
   *
   * @generated from field: int32 weekly_notice_lead_days = 7;
   */
  weeklyNoticeLeadDays: number;

  /**
   * 週次通告の締切時刻 (JST HH:MM)。has_weekly_notice=false の場合は unset。
   *
   * @generated from field: google.type.TimeOfDay weekly_notice_cutoff_time = 8;
   */
  weeklyNoticeCutoffTime?: TimeOfDay;

  /**
   * オプション基本料金 (円/MW・月)。未設定の場合は unset。
   *
   * @generated from field: optional google.type.Decimal option_base_fee_per_mw = 11;
   */
  optionBaseFeePerMw?: Decimal;

  /**
   * オプション備考 (任意)。
   *
   * @generated from field: optional string option_remarks = 12;
   */
  optionRemarks?: string;
};

/**
 * Describes the message bffuser.v1.BilateralTradeOption.
 * Use `create(BilateralTradeOptionSchema)` to create a new message.
 */
export const BilateralTradeOptionSchema: GenMessage<BilateralTradeOption> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 10);

/**
 * BilateralTrade は Get/Create/Update の full response message。
 *
 * #6236 (Design Decision 2) で旧 BilateralTradeLeg (response の repeated
 * legs) を撤去しフラット化した。1 取引 = 1 契約 = 1 数量・単価単位 (ADR
 * trading-contract-one-to-one) のため、売買区分 / エリア / 数量 / 受渡期間 /
 * 時間帯区分 といった旧 leg 単位の値は本 message 直下のフィールドとして読む。
 * Mirrors internalapi.v1.BilateralTrade.
 *
 * @generated from message bffuser.v1.BilateralTrade
 */
export type BilateralTrade = Message<"bffuser.v1.BilateralTrade"> & {
  /**
   * 取引 UUID。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * deal_id: スプレッド取引グルーピング用外部識別子。
   *
   * @generated from field: string deal_id = 2;
   */
  dealId: string;

  /**
   * 取引識別コード。空欄で登録された場合は採番済みの値。
   *
   * @generated from field: string public_trade_id = 3;
   */
  publicTradeId: string;

  /**
   * 取引先マスタ UUID。取引所取引では空。
   *
   * @generated from field: string trading_partner_id = 5;
   */
  tradingPartnerId: string;

  /**
   * 取引先名称 (スナップショット保持)。
   *
   * @generated from field: string partner_name = 6;
   */
  partnerName: string;

  /**
   * 受渡区分。契約レベル単一値。
   *
   * @generated from field: bfftypes.v1.TradingDeliveryType delivery_type = 9;
   */
  deliveryType: TradingDeliveryType;

  /**
   * オプション有無。
   *
   * @generated from field: bool is_option = 13;
   */
  isOption: boolean;

  /**
   * オプション通告ルール。is_option=false の場合は unset。
   *
   * @generated from field: bffuser.v1.BilateralTradeOption option = 14;
   */
  option?: BilateralTradeOption;

  /**
   * 備考 (任意)。
   *
   * @generated from field: optional string remarks = 15;
   */
  remarks?: string;

  /**
   * 手入力フラグ。
   *
   * @generated from field: bool is_manual = 16;
   */
  isManual: boolean;

  /**
   * 約定経路 (7 値)。
   *
   * @generated from field: bfftypes.v1.TradingExecutionRoute execution_route = 17;
   */
  executionRoute: TradingExecutionRoute;

  /**
   * ライフサイクル状態。
   *
   * @generated from field: bfftypes.v1.TradingContractStatus status = 18;
   */
  status: TradingContractStatus;

  /**
   * 楽観的排他制御用タイムスタンプ (µs 精度)。
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 19;
   */
  updatedAt?: Timestamp;

  /**
   * 最終更新者のユーザー識別子。
   *
   * @generated from field: string updated_by = 20;
   */
  updatedBy: string;

  /**
   * 作成日時。
   *
   * @generated from field: google.protobuf.Timestamp created_at = 21;
   */
  createdAt?: Timestamp;

  /**
   * 作成者のユーザー識別子。
   *
   * @generated from field: string created_by = 22;
   */
  createdBy: string;

  /**
   * 約定日。
   *
   * @generated from field: google.type.Date execution_date = 23;
   */
  executionDate?: Date;

  /**
   * 商品形態 (標準 / スプレッド / 非定型)。永続化されない導出値。
   *
   * @generated from field: bfftypes.v1.BilateralTradeProductType product_type = 24;
   */
  productType: BilateralTradeProductType;

  /**
   * スプレッド種別 (product_type=SPREAD のときのみ非空)。
   *
   * @generated from field: repeated bfftypes.v1.TradingSpreadKind spread_kinds = 25;
   */
  spreadKinds: TradingSpreadKind[];

  /**
   * 利用率下限 (0-1 スケール)。unset 可。
   *
   * @generated from field: google.type.Decimal utilization_rate_min = 26;
   */
  utilizationRateMin?: Decimal;

  /**
   * 利用率上限 (0-1 スケール)。unset 可。
   *
   * @generated from field: google.type.Decimal utilization_rate_max = 27;
   */
  utilizationRateMax?: Decimal;

  /**
   * 売買区分。
   *
   * @generated from field: bfftypes.v1.Side buy_sell = 29;
   */
  buySell: Side;

  /**
   * エリアコード (自社エリア)。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 30;
   */
  areaCode: AreaCode;

  /**
   * 受渡開始日。
   *
   * @generated from field: google.type.Date delivery_period_from = 31;
   */
  deliveryPeriodFrom?: Date;

  /**
   * 受渡終了日。
   *
   * @generated from field: google.type.Date delivery_period_to = 32;
   */
  deliveryPeriodTo?: Date;

  /**
   * 時間帯区分。**UNSPECIFIED = カスタム時間帯** (custom_* を参照する)。
   *
   * @generated from field: bfftypes.v1.TradingTimeZoneType time_zone_type = 33;
   */
  timeZoneType: TradingTimeZoneType;

  /**
   * カスタム時間帯の 日区分 ↔ 時刻レンジ ペア列 (標準時間帯では空)。
   * 日区分は 3 値の単一値で返す。34 / 35
   * (custom_day_categories / custom_time_slots) の直積表現を置き換えたもの。
   *
   * @generated from field: repeated bffuser.v1.CustomBand custom_bands = 46;
   */
  customBands: CustomBand[];

  /**
   * 契約電力量 (MW)。
   *
   * @generated from field: google.type.Decimal volume_mw = 36;
   */
  volumeMw?: Decimal;

  /**
   * 契約単価 (円/kWh)。unset 可。
   *
   * @generated from field: google.type.Decimal unit_price_yen_per_kwh = 37;
   */
  unitPriceYenPerKwh?: Decimal;

  /**
   * 自社 BG / 計画提出者コード (5 桁)。
   *
   * @generated from field: string own_submission_entity_code = 38;
   */
  ownSubmissionEntityCode: string;

  /**
   * 取引先 BG / 計画提出者コード (5 桁、スナップショット)。
   *
   * @generated from field: string partner_submission_entity_code = 39;
   */
  partnerSubmissionEntityCode: string;

  /**
   * 精算単価参照エリア。未設定の場合は UNSPECIFIED。
   *
   * @generated from field: bfftypes.v1.AreaCode settlement_price_area_code = 40;
   */
  settlementPriceAreaCode: AreaCode;

  /**
   * 受給日カレンダー。未設定の場合は UNSPECIFIED。
   *
   * @generated from field: bfftypes.v1.DeliveryCalendarKey calendar_key = 41;
   */
  calendarKey: DeliveryCalendarKey;

  /**
   * 受渡カレンダー例外 (日単位)。
   *
   * @generated from field: repeated bffuser.v1.BilateralTradeCalendarException calendar_exceptions = 42;
   */
  calendarExceptions: BilateralTradeCalendarException[];

  /**
   * 受給時間 (h)。契約時スナップショット。unset 可 (読取表示のみ)。
   *
   * @generated from field: google.type.Decimal supply_hours = 43;
   */
  supplyHours?: Decimal;

  /**
   * 電力量 (kWh)。契約時スナップショット。unset 可 (読取表示のみ)。
   *
   * @generated from field: google.type.Decimal energy_kwh = 44;
   */
  energyKwh?: Decimal;

  /**
   * 自社事業者コード (OCCTO 4 桁、JP06316 系)。読取専用表示のみ
   * (BilateralTradeInput には持たない)。
   * Mirrors internalapi.v1.BilateralTrade.own_business_cd。
   *
   * @generated from field: string own_business_cd = 45;
   */
  ownBusinessCd: string;
};

/**
 * Describes the message bffuser.v1.BilateralTrade.
 * Use `create(BilateralTradeSchema)` to create a new message.
 */
export const BilateralTradeSchema: GenMessage<BilateralTrade> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 11);

/**
 * BilateralTradeCsvRowResult はチェック RPC が返す差分プレビューの 1 行。
 * Mirrors internalapi.v1.BilateralTradeCsvRowResult.
 *
 * @generated from message bffuser.v1.BilateralTradeCsvRowResult
 */
export type BilateralTradeCsvRowResult = Message<"bffuser.v1.BilateralTradeCsvRowResult"> & {
  /**
   * CSV のデータ行番号 (1 起算、ヘッダー行を除く)。
   *
   * @generated from field: int32 row_number = 1;
   */
  rowNumber: number;

  /**
   * 行ステータス (5 状態)。
   *
   * @generated from field: bffuser.v1.BilateralTradeCsvRowStatus status = 2;
   */
  status: BilateralTradeCsvRowStatus;

  /**
   * 取引識別コード (突合キー)。空欄行では空。
   *
   * @generated from field: string public_trade_id = 3;
   */
  publicTradeId: string;

  /**
   * エラー理由 (status=ERROR のときのみ)。
   *
   * @generated from field: string message = 5;
   */
  message: string;
};

/**
 * Describes the message bffuser.v1.BilateralTradeCsvRowResult.
 * Use `create(BilateralTradeCsvRowResultSchema)` to create a new message.
 */
export const BilateralTradeCsvRowResultSchema: GenMessage<BilateralTradeCsvRowResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 12);

/**
 * BilateralTradeRecap holds the full detail of a single bilateral trade for
 * the Recap modal view.
 * Separate from BilateralTradeListItem because the display fields differ
 * (list intentionally omits unit price, total amount, and supply hours).
 *
 * @generated from message bffuser.v1.BilateralTradeRecap
 */
export type BilateralTradeRecap = Message<"bffuser.v1.BilateralTradeRecap"> & {
  /**
   * 取引 UUID。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 成約 ID (社内採番 SC-YYYYMMDD-NNN)。
   *
   * @generated from field: string deal_id = 2;
   */
  dealId: string;

  /**
   * 取引 ID (取引プラットフォームが採番した公開 ID)。
   *
   * @generated from field: string public_trade_id = 3;
   */
  publicTradeId: string;

  /**
   * 契約ステータス。
   *
   * @generated from field: bfftypes.v1.TradingContractStatus status = 4;
   */
  status: TradingContractStatus;

  /**
   * 約定日。
   *
   * @generated from field: google.type.Date execution_date = 5;
   */
  executionDate?: Date;

  /**
   * 約定経路 (enechain / eSquare Live / 手入力)。
   *
   * @generated from field: bfftypes.v1.TradingExecutionRoute execution_route = 6;
   */
  executionRoute: TradingExecutionRoute;

  /**
   * 売買区分。
   *
   * @generated from field: bfftypes.v1.Side buy_sell = 7;
   */
  buySell: Side;

  /**
   * 受渡区分 (enum 固定値)。 旧 delivery_type_id (UUID) から enum に変更。
   * frontend は enum 値から表示名 / 派生属性をマッピング関数で解決する (マスタ行 fetch 不要)。
   *
   * @generated from field: bfftypes.v1.TradingDeliveryType delivery_type = 8;
   */
  deliveryType: TradingDeliveryType;

  /**
   * 相対先の名称。
   *
   * @generated from field: string partner_name = 9;
   */
  partnerName: string;

  /**
   * エリアコード。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 10;
   */
  areaCode: AreaCode;

  /**
   * 受渡期間 (開始日)。
   *
   * @generated from field: google.type.Date delivery_period_from = 11;
   */
  deliveryPeriodFrom?: Date;

  /**
   * 受渡期間 (終了日)。
   *
   * @generated from field: google.type.Date delivery_period_to = 12;
   */
  deliveryPeriodTo?: Date;

  /**
   * 時間帯区分 (BASE / PEAK / OFF_PEAK 等)。
   *
   * @generated from field: bfftypes.v1.TradingTimeZoneType time_zone_type = 13;
   */
  timeZoneType: TradingTimeZoneType;

  /**
   * オプション条項あり/なし。
   *
   * @generated from field: bool has_option = 14;
   */
  hasOption: boolean;

  /**
   * 実績利用率 (0-1 スケール、 例: 0.7 は 70%)。has_option=false の場合は unset。
   *
   * @generated from field: google.type.Decimal actual_utilization_rate = 15;
   */
  actualUtilizationRate?: Decimal;

  /**
   * 利用率下限 (0-1 スケール、 例: 0.7 は 70%)。has_option=false の場合は unset。精度敏感のため google.type.Decimal。
   *
   * @generated from field: google.type.Decimal utilization_rate_min = 21;
   */
  utilizationRateMin?: Decimal;

  /**
   * 利用率上限 (0-1 スケール、 例: 0.7 は 70%)。has_option=false の場合は unset。精度敏感のため google.type.Decimal。
   *
   * @generated from field: google.type.Decimal utilization_rate_max = 22;
   */
  utilizationRateMax?: Decimal;

  /**
   * 通告タイミング (日次通告の実需給 N 日前、 AC-009: 「当日」=0 / 「実需給 N 日前」=N>=1
   * は frontend 表示側で N から導出する)。 has_option=false のとき、 または現在有効な
   * 日次通告ルールが無いとき (= 週次のみ構成、 #1319 と同型の PO 確認事項) は unset
   * (= spec データ定義表の「非表示」)。 精度懸念のない小さい整数 (0-30 程度) の
   * ため google.type.Decimal ではなく plain int32 + optional。
   *
   * @generated from field: optional int32 daily_notice_lead_days = 23;
   */
  dailyNoticeLeadDays?: number;

  /**
   * 契約電力量 (MW)。精度敏感のため google.type.Decimal。unset 可。
   *
   * @generated from field: google.type.Decimal volume_mw = 16;
   */
  volumeMw?: Decimal;

  /**
   * 受給時間 (h)。stored 値。精度敏感のため google.type.Decimal。unset 可。
   *
   * @generated from field: google.type.Decimal supply_hours = 17;
   */
  supplyHours?: Decimal;

  /**
   * 電力量 (kWh)。stored 値。精度敏感のため google.type.Decimal。unset 可。
   *
   * @generated from field: google.type.Decimal energy_kwh = 18;
   */
  energyKwh?: Decimal;

  /**
   * 契約単価 (円/kWh)。精度敏感のため google.type.Decimal。unset 可。
   *
   * @generated from field: google.type.Decimal unit_price_yen_per_kwh = 19;
   */
  unitPriceYenPerKwh?: Decimal;

  /**
   * 電力量料金 (円)。backend converter 計算値 (= energy_kwh × unit_price_yen_per_kwh)。
   * unset 可 (energy_kwh / unit_price_yen_per_kwh のどちらかが unset の場合は unset)。
   *
   * @generated from field: google.type.Decimal total_amount_yen = 20;
   */
  totalAmountYen?: Decimal;

  /**
   * 取引先コード (取引先 BG / 計画提出者コード 5 桁、契約時スナップショット)。
   * Recap の「取引先」欄で名称に括弧併記する (issue #7045)。未登録は空文字。
   * Mirrors internalapi.v1.BilateralTradeRecap.partner_submission_entity_code.
   *
   * @generated from field: string partner_submission_entity_code = 24;
   */
  partnerSubmissionEntityCode: string;
};

/**
 * Describes the message bffuser.v1.BilateralTradeRecap.
 * Use `create(BilateralTradeRecapSchema)` to create a new message.
 */
export const BilateralTradeRecapSchema: GenMessage<BilateralTradeRecap> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 13);

/**
 * ExportBilateralTradesRow is one CSV data row (= 1 独立契約) of 相対取引契約 の
 * 入稿済みデータのダウンロード (uploads/common.md §6 AC-DUC-028/029)。
 * Mirrors internalapi.v1.ExportBilateralTradesRow — 全列 string である理由
 * (CSV 語彙の SoT を backend に一本化し、frontend に業務ルールを二重実装
 * しない) は internalapi 側のコメントを参照。区分値の列の言語は
 * ExportBilateralTradesRequest.language に従う (以下の列コメントの例は日本語のもの)。
 *
 * @generated from message bffuser.v1.ExportBilateralTradesRow
 */
export type ExportBilateralTradesRow = Message<"bffuser.v1.ExportBilateralTradesRow"> & {
  /**
   * 列1 約定経路。
   *
   * @generated from field: string execution_route = 1;
   */
  executionRoute: string;

  /**
   * 列2 約定日 (YYYY/MM/DD)。
   *
   * @generated from field: string execution_date = 2;
   */
  executionDate: string;

  /**
   * 列3 取引ID。各契約が自分自身の public_trade_id を名乗る (旧: 成約グループの
   * 代表取引IDへ束ねる仕様。leg 概念の廃止に伴い撤去済み)。
   *
   * @generated from field: string public_trade_id = 3;
   */
  publicTradeId: string;

  /**
   * 列4 自社側事業者コード。
   *
   * @generated from field: string own_business_code = 5;
   */
  ownBusinessCode: string;

  /**
   * 列5 自社側BG/計画提出者コード。
   *
   * @generated from field: string own_submission_entity_code = 6;
   */
  ownSubmissionEntityCode: string;

  /**
   * 列6 取引先。
   *
   * @generated from field: string partner_name = 7;
   */
  partnerName: string;

  /**
   * 列7 取引先BG/計画提出者コード。
   *
   * @generated from field: string partner_submission_entity_code = 8;
   */
  partnerSubmissionEntityCode: string;

  /**
   * 列8 商品形態 ("定型" / "非定型")。
   *
   * @generated from field: string product_type = 9;
   */
  productType: string;

  /**
   * 列9 受渡区分。
   *
   * @generated from field: string delivery_type = 10;
   */
  deliveryType: string;

  /**
   * 列10 自社売買区分 ("買" / "売")。
   *
   * @generated from field: string buy_sell = 11;
   */
  buySell: string;

  /**
   * 列11 自社エリア。
   *
   * @generated from field: string area_code = 12;
   */
  areaCode: string;

  /**
   * 列12 精算単価参照エリア。未設定は空文字。
   *
   * @generated from field: string settlement_price_area_code = 13;
   */
  settlementPriceAreaCode: string;

  /**
   * 列13 開始日 (YYYY/MM/DD)。
   *
   * @generated from field: string period_from = 14;
   */
  periodFrom: string;

  /**
   * 列14 終了日 (YYYY/MM/DD)。
   *
   * @generated from field: string period_to = 15;
   */
  periodTo: string;

  /**
   * 列15 日区分。
   *
   * @generated from field: string day_category = 16;
   */
  dayCategory: string;

  /**
   * 列16 時間帯区分。
   *
   * @generated from field: string time_slots = 17;
   */
  timeSlots: string;

  /**
   * 列17 受給日カレンダー。未設定は空文字。
   *
   * @generated from field: string calendar_key = 18;
   */
  calendarKey: string;

  /**
   * 列18 数量MW。未設定は空文字。
   *
   * @generated from field: string volume_mw = 19;
   */
  volumeMw: string;

  /**
   * 列19 単価(円/kWh)。
   *
   * @generated from field: string unit_price = 20;
   */
  unitPrice: string;

  /**
   * 列20 Delete。常に空文字。
   *
   * @generated from field: string delete = 21;
   */
  delete: string;
};

/**
 * Describes the message bffuser.v1.ExportBilateralTradesRow.
 * Use `create(ExportBilateralTradesRowSchema)` to create a new message.
 */
export const ExportBilateralTradesRowSchema: GenMessage<ExportBilateralTradesRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_supply_bilateral_trade_model, 14);

/**
 * ESLSyncStatus represents the synchronisation result of the eSquare Live
 * (eSL) API for the most recent fetch. Mirrors internalapi.v1.ESLSyncStatus.
 *
 * Deprecated: backend は値を設定しない (常に UNSPECIFIED)。途絶の警告は
 * BilateralTradeImportStaleness を使う。新 frontend が全環境に配備された後に
 * 削除する (削除時は ListBilateralTradesResponse.esl_sync_status の番号 5 を
 * reserved にする)。
 *
 * @generated from enum bffuser.v1.ESLSyncStatus
 */
export enum ESLSyncStatus {
  /**
   * @generated from enum value: ESL_SYNC_STATUS_UNSPECIFIED = 0;
   */
  ESL_SYNC_STATUS_UNSPECIFIED = 0,

  /**
   * eSL API からの同期が正常完了した。
   *
   * @generated from enum value: ESL_SYNC_STATUS_SYNCED = 1;
   */
  ESL_SYNC_STATUS_SYNCED = 1,

  /**
   * eSL API エラーにより同期をスキップした。
   *
   * @generated from enum value: ESL_SYNC_STATUS_SKIPPED_API_ERROR = 2;
   */
  ESL_SYNC_STATUS_SKIPPED_API_ERROR = 2,
}

/**
 * Describes the enum bffuser.v1.ESLSyncStatus.
 */
export const ESLSyncStatusSchema: GenEnum<ESLSyncStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_supply_bilateral_trade_model, 0);

/**
 * BilateralTradeCsvRowStatus は契約マスタ CSV チェック結果の 1 行ステータス
 * (共通仕様 admin/data/uploads/common.md の 5 状態)。
 * Mirrors internalapi.v1.BilateralTradeCsvRowStatus.
 *
 * @generated from enum bffuser.v1.BilateralTradeCsvRowStatus
 */
export enum BilateralTradeCsvRowStatus {
  /**
   * @generated from enum value: BILATERAL_TRADE_CSV_ROW_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 変更なし。
   *
   * @generated from enum value: BILATERAL_TRADE_CSV_ROW_STATUS_UNCHANGED = 1;
   */
  UNCHANGED = 1,

  /**
   * 新規。
   *
   * @generated from enum value: BILATERAL_TRADE_CSV_ROW_STATUS_CREATED = 2;
   */
  CREATED = 2,

  /**
   * 変更 (論理削除済みの復活を含む)。
   *
   * @generated from enum value: BILATERAL_TRADE_CSV_ROW_STATUS_UPDATED = 3;
   */
  UPDATED = 3,

  /**
   * 削除。
   *
   * @generated from enum value: BILATERAL_TRADE_CSV_ROW_STATUS_DELETED = 4;
   */
  DELETED = 4,

  /**
   * エラー (1 件でもあれば確定は全体拒否)。
   *
   * @generated from enum value: BILATERAL_TRADE_CSV_ROW_STATUS_ERROR = 5;
   */
  ERROR = 5,
}

/**
 * Describes the enum bffuser.v1.BilateralTradeCsvRowStatus.
 */
export const BilateralTradeCsvRowStatusSchema: GenEnum<BilateralTradeCsvRowStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_supply_bilateral_trade_model, 1);

